import { useCrfFormSubmit } from "@ngt/opms";
import { IConsentForm } from "../../api/dtos";

const useEConsentFormSubmit =  <TData extends IConsentForm = IConsentForm>() => {
    return useCrfFormSubmit<TData>();
};

export default useEConsentFormSubmit;